export { EXTRA_CONTENT_TYPES, contentTypesWithTheHtmlEditor } from './constants';

export const filterSelectedObjects = (selectedObjects, valueField = 'id') => {
  const selectedObjectValues = (selectedObjects || []).reduce((acc, item) => {
    if (typeof item[valueField] === 'undefined') {
      throw new Error(`Property ${valueField} is undefined.`);
    }

    const draftAcc = { ...acc };
    draftAcc[`item-${item[valueField]}`] = true;

    return draftAcc;
  }, {});

  return item => selectedObjectValues[`item-${item[valueField]}`];
};

export const filterSelectedValues = (selectedValues, valueField = null) => {
  const selectedValuesPair = (selectedValues || []).reduce((acc, item) => {
    const draftAcc = { ...acc };
    draftAcc[`item-${item}`] = true;

    return draftAcc;
  }, {});

  return item => selectedValuesPair[`item-${valueField ? item[valueField] : item}`];
};

export const negateFn = fn => (...args) => !fn(...args);

export const selectionSorter = (filterFn, ...args) => (items, values) => {
  const selected = items.filter(filterFn(values, ...args));
  const notSelected = items.filter(negateFn(filterFn(values, ...args)));

  return [...selected, ...notSelected];
};
